import { useState, useEffect, useCallback } from 'react';

// Available map tile providers (no API key required) - ordered by weight (lightest first)
export const MAP_PROVIDERS = {
  osm: {
    name: 'OpenStreetMap',
    description: 'Clásico, ligero y rápido (por defecto)',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    subdomains: 'abc',
    weight: '~5-10KB/tile'
  },
  cyclosm: {
    name: 'CyclOSM',
    description: 'Outdoor/ciclismo, muestra caminos',
    url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="https://www.cyclosm.org">CyclOSM</a>',
    subdomains: 'abc',
    weight: '~10-15KB/tile'
  },
  opentopomap: {
    name: 'OpenTopoMap',
    description: 'Topográfico detallado (más pesado)',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="https://opentopomap.org">OpenTopoMap</a>',
    subdomains: 'abc',
    weight: '~20-30KB/tile'
  }
};

const STORAGE_KEY = 'strategos_map_provider';
const DEFAULT_PROVIDER = 'osm';

export function useMapProvider() {
  const [provider, setProvider] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && MAP_PROVIDERS[saved]) {
        return saved;
      }
    }
    return DEFAULT_PROVIDER;
  });

  const [tileConfig, setTileConfig] = useState(MAP_PROVIDERS[DEFAULT_PROVIDER]);

  // Update tile config when provider changes
  useEffect(() => {
    const config = MAP_PROVIDERS[provider] || MAP_PROVIDERS[DEFAULT_PROVIDER];
    setTileConfig(config);
  }, [provider]);

  // Save preference to localStorage
  const changeProvider = useCallback((newProvider) => {
    if (MAP_PROVIDERS[newProvider]) {
      setProvider(newProvider);
      localStorage.setItem(STORAGE_KEY, newProvider);
    }
  }, []);

  return {
    provider,
    tileConfig,
    changeProvider,
    availableProviders: MAP_PROVIDERS
  };
}

export default useMapProvider;
